import {
  CarEBoxLocations,
  ADRClasses,
  CarsLocationSharingConstraints,
  CarsLocationSharing,
  CarsLocationSharingForm,
  CarLocationHistorySharing
} from '../types';

import { locatorServiceAPI } from 'shared/services';

export const carsAPI = {
  getCarEBoxLocations: () => locatorServiceAPI.get<CarEBoxLocations>('navigation/autosCoordinates'),
  getADRClasses: () => locatorServiceAPI.get<ADRClasses>('routes/adr-classes'),
  getCarsLocationSharingConstraints: () => locatorServiceAPI.get<CarsLocationSharingConstraints>('location-sharing-links/constraints'),
  addCarsLocationSharing: (form: CarsLocationSharingForm) => locatorServiceAPI.post<CarsLocationSharing>('location-sharing-links', form),
  getCarsLocationSharing: () => locatorServiceAPI.get<CarsLocationSharing[]>('location-sharing-links'),
  deleteCarLocationSharing: (id: CarsLocationSharing['id']) => locatorServiceAPI.delete<{}>(`location-sharing-links/${id}`),
  getCarLocationHistorySharing: (id: CarsLocationSharing['id']) => locatorServiceAPI.get<CarLocationHistorySharing>(`public/location-sharing-links/${id}`),
}
